import { useCallback, useState } from 'react';
import Panel from './Panel';
import { useCmdKPress } from './hooks';

/**
 * The entrypoint for the CommandPalette.
 * This component is responsible for rendering the input field
 * and the panel that appears when the input field is focused.
 */
const CommandPalette = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const onHide = useCallback(() => setIsOpen(false), []);
  const toggleOpen = useCallback(() => setIsOpen(!isOpen), [isOpen]);
  useCmdKPress(toggleOpen);

  if (!isOpen) {
    return null;
  }

  return <Panel onHide={onHide} isOpen={isOpen} />;
};

export default CommandPalette;
